module.exports = __webpack_public_path__ + "92c74d6727e5ebd0682ce0cc3f873481.png";